<template>
  <div @click.stop="expanded=!expanded">
    <div class="log-icon large-logo iconfont icon-notify">
      <slot name="badge"/>
    </div>
    <div class="flex log-content">
      <div class="log-node-name">{{log.name}}</div>
      <div class="log-participant">{{log.state!==-2?'已':''}}抄送{{log.items.length}}人</div>
      <div @click.stop="" v-show="expanded" class="layout participant-list">
        <div class="participant" v-for="(participant,index) in log.items" :key="index" >
          <div class="participant-icon">
            <span>{{participant.participantName[0]}}</span>
            <span v-if="participant.state === 1" class="badge iconfont icon-wf-pass"></span>
          </div>
          <div class="participant-desc">{{participant.participantName}}</div>
        </div>
      </div>
    </div>
    <div class="toggle-expand"
         :class="expanded?'icon-arrow-up':'icon-arrow-down'"></div>
  </div>
</template>

<script>
  export default {
    name: "log-notify",
    props: ["log"],
    data() {
      return {expanded: this.log.state !== -2};
    },
  }
</script>

<style scoped>

</style>
